import { z } from "@msuite/utils/lib/zod";
import { defineQuery } from "@rocicorp/zero";
import { zql } from "../zql";

/**
 * The drops one person is watching, live.
 *
 * A batch is asked for by id rather than listed, and more than one at a time, because a second
 * drop landing while the first is still in flight is a second upload id — the pill follows both
 * and reports one figure over the two.
 *
 * **The `createdBy` clause is the wall, not the decoration.** Reading a file asks no rule — every
 * member reads the organisation's files — so without it any member who guessed a batch id would
 * receive somebody else's upload as it happened. A batch is the private business of whoever
 * dropped it.
 */
export const fileClassificationQueries = {
	byBatches: defineQuery(
		z.object({
			batchIds: z.array(z.string()).min(1).max(20),
		}),
		({ args, ctx }) => {
			return zql.fileClassifications
				.where("orgId", "=", ctx.orgId)
				.where("createdBy", "=", ctx.userId)
				.where("batchId", "IN", args.batchIds)
				.related("file", (file) => file.where("orgId", "=", ctx.orgId));
		},
	),
};
